import React from 'react';
import { useTranslation } from 'react-i18next';
import { LogIn, Loader2 } from 'lucide-react';

import {
  Button,
  Card,
  CardHeader,
  CardTitle,
  CardDescription,
  CardContent,
} from '../components/ui';
import LanguageSelector from '../components/ui/LanguageSelector';
import { useAuth } from '../hooks/useAuth';

export const SignInPage: React.FC = () => {
  const { t } = useTranslation();
  const { signIn, isLoading } = useAuth();

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <div className="absolute top-4 right-4">
        <LanguageSelector dropdownDirection="below" variant="expanded" />
      </div>

      <Card className="w-full max-w-md mx-auto">
        <CardHeader className="text-center">
          <div className="w-20 h-12 flex items-center justify-center mx-auto mb-4">
            <img src="/um-logo.webp" alt="UM" className="h-10 w-auto" />
          </div>
          <CardTitle>{t('auth.welcomeBack')}</CardTitle>
          <CardDescription>{t('auth.pleaseSignIn')}</CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <Button
            onClick={signIn}
            className="w-full gap-2 h-12"
            disabled={isLoading}
          >
            {isLoading ? (
              <Loader2 className="w-4 h-4 animate-spin" />
            ) : (
              <LogIn className="w-4 h-4" />
            )}
            {isLoading ? t('auth.signingIn') : t('auth.signin')}
          </Button>

          <p className="text-xs text-muted-foreground text-center">
            {t(
              'auth.termsAndPrivacy',
              "By signing in, you agree to UM's terms of service and privacy policy."
            )}
          </p>
        </CardContent>
      </Card>
    </div>
  );
};
